export default class CountrySearchResponse {

    constructor(jsonObj) {
        this.id = jsonObj["id"];
        this.countryName = jsonObj["name"];
        this.code = jsonObj["code"];

        this.name = this.countryName + " (" + this.code + ")";

    }

}